<template>
    <div class="search-box">
        <el-icon class="search-icon" @click="isActiveSearchModal = true"><Search /></el-icon>

        <div @click.self="isActiveSearchModal = false" :class="isActiveSearchModal ? 'active' : ''" class="search-box-modal pt-50 d-flex align-start justify-center position-fixed">
            <form @submit.prevent="submitSearch">
                <div class="input-group position-relative">
                    <el-icon class="position-absolute"><Search /></el-icon>
                    <input v-model="searchValue" placeholder="Search Posts" />
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Search } from '@element-plus/icons-vue';

export default {
    name: 'SearchBox',
    components: {
        Search
    },
    data() {
        return {
            isActiveSearchModal: false,
            searchValue: ''
        }
    },
    methods: {
        submitSearch() {
            window.location = '/search?s='+this.searchValue;
        }
    }
}
</script>